import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { Check, ArrowRight, Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="offer" className="w-full py-24 px-6 bg-night-500 relative" data-id="element-115">
      <div className="max-w-3xl mx-auto" data-id="element-116">
        <FadeIn className="bg-night-400 border border-night-300 rounded-3xl overflow-hidden shadow-2xl relative" data-id="element-117">
          {/* Top accent bar */}
          <div className="h-2 w-full bg-amber-warm" data-id="element-118" />

          <div className="p-8 md:p-12 space-y-10" data-id="element-119">
            <div className="text-center space-y-4" data-id="element-120">
              <h2 className="font-serif text-3xl md:text-4xl text-night-50" data-id="element-121">
                Empieza esta misma noche
              </h2>
              <p className="text-night-100 text-lg" data-id="element-122">
                Si esta noche vuelve a ser igual… te vas a levantar igual.
              </p>
            </div>

            <div className="grid md:grid-cols-2 gap-8 py-8 border-y border-night-300" data-id="element-123">
              <div className="space-y-4" data-id="element-124">
                <h3 className="font-serif text-xl text-night-50" data-id="element-125">
                  Qué recibes:
                </h3>
                <ul className="space-y-3" data-id="element-126">
                  {['PDF Guía Completa (Paso a paso)', 'Hoja Imprimible "Night Scripts"', 'Tracker de 14 días para medir progreso', 'Acceso inmediato y de por vida'].map((item, i) => <li key={i} className="flex items-start gap-3 text-night-100" data-id="element-127">
                      <Check className="w-5 h-5 text-amber-warm shrink-0" data-id="element-128" />
                      <span data-id="element-129">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="flex flex-col items-center justify-center bg-night-500/50 rounded-xl p-6 border border-night-300/50" id="pricing" data-id="element-130">
                <span className="text-night-100 text-sm uppercase tracking-wider mb-2" data-id="element-131">
                  Precio Único
                </span>
                <div className="flex items-baseline gap-1" data-id="element-132">
                  <span className="text-5xl font-serif text-night-50" data-id="element-133">
                    $6.36
                  </span>
                  <span className="text-night-100" data-id="element-134">USD</span>
                </div>
                <p className="text-xs text-night-100 mt-4 text-center max-w-[200px]" data-id="element-135">
                  Menos de lo que gastas en cafés para sobrevivir la semana.
                </p>
              </div>
            </div>

            <div className="space-y-6" data-id="element-136">
              <a href="https://doctormomstudio.com/cart/52252112945333:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', {
                value: 29,
                currency: 'USD',
                content_name: 'Dormir 5 Horas Seguidas'
              });
            }} className="w-full group relative flex items-center justify-center px-8 py-5 text-xl font-medium text-night-500 bg-amber-warm rounded-full overflow-hidden transition-all duration-300 hover:bg-amber-glow hover:shadow-[0_0_30px_rgba(232,168,56,0.3)]" data-id="element-137">
                <span className="relative z-10 flex items-center" data-id="element-138">
                  Quiero el Reset de 14 Noches
                  <ArrowRight className="ml-2 w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-139" />
                </span>
              </a>

              <div className="flex items-center justify-center gap-2 text-night-100 text-sm" data-id="element-140">
                <Lock className="w-3 h-3" data-id="element-141" />
                <span data-id="element-142">Pago seguro y encriptado. Descarga inmediata.</span>
              </div>
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="mt-12 text-center space-y-6 max-w-2xl mx-auto" data-id="element-143">
          <h3 className="font-serif text-2xl text-night-50" data-id="element-144">Qué NO es esto</h3>
          <div className="flex flex-wrap justify-center gap-3" data-id="element-145">
            {['No es magia', 'No es una promesa médica', 'No es teoría bonita', 'No es ignorar el llanto'].map((item, i) => <span key={i} className="px-4 py-2 rounded-full bg-night-400 border border-night-300 text-night-100 text-sm" data-id="element-146">
                {item}
              </span>)}
          </div>
          <p className="text-night-100 italic" data-id="element-147">
            Es un sistema simple para noches reales.
          </p>
        </FadeIn>
      </div>
    </section>;
}